import React from 'react';
import { connect } from 'react-redux';
import {
  instructionVersionsParagraphAdd,
  instructionWasEdited
} from '../actions/instuctionActions';

function AddComponentSection({versionIndex, dispatch, versions, disable}) {
  const instructionVersionsData = (paragraph) => {
    dispatch(instructionVersionsParagraphAdd(versionIndex, paragraph));
    dispatch(instructionWasEdited(true));
  };

  const addOkNok = () => {
    instructionVersionsData({
      "type" : "okNok",
      "descriptionOK" : "",
      "labelOK" : false,
      "descriptionNOK" : "",
      "labelNOK" : false,
      "attachments": [{},{}]//[{OK},{NOK}] attachments
    })
  }
  const addTextField = () => {
    instructionVersionsData(
      {
        "type" : "textField",
        "description" : ""
    })
  }

  const addPoint = () => {
    const pointNumber = versions[versionIndex].data.filter(paragraph => {
      return paragraph.type === "point";
    }).length;
    instructionVersionsData({
      "type" : "point",
      "title" : "",
      "description" : "",
      "attachments": [],
      "pointNumber": pointNumber + 1,
      "headerDescription": ""
    })
  }

  const addSection = () => {
    instructionVersionsData({
      "type" : "section",
      "title" : "",
      "description" : "",
      "attachments": []
    })
  }

  const addGeneralPhoto = () => {
    instructionVersionsData({
      "type" : "generalPhoto",
      "attachments" : [{attachmentUrl: "", attachmentOriginalName: ""}]
    })
  }

  let content = ""
  if(!disable) {
    content = (
      <div>
      <button onClick={addGeneralPhoto}>general photo section</button><br/>
      <button onClick={addOkNok}>divided photo section</button><br/>
      <button onClick={addTextField}>text</button><br/>
      <button onClick={addPoint}>add point</button><br/>
      <button onClick={addSection}>add section</button>
    </div>)
  }
  return (
    <>{content}</>
  )
}

function mapStateToProps ({ instructionsReducer }) {
  return {
    ...instructionsReducer
  };
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddComponentSection);
